import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from '../../../../utility/http/http-events';
import configureInterceptors from 'utility/http/interceptors/configure-interceptors';
import { store } from '@redux/storeConfig/store';
import { apiConstants } from '@configs/constants';

export interface UnitVideoChannel {
  unitId: number;
  deviceId: number;
  channelId: number;
  channelName: string;
  auditDate?: string;
  auditUserId?: number;
  videoStreamingChannels?: number;
}

export interface UpdateChannelNameRequest {
  newChannelName: string;
  auditUserId: number;
}

export interface CreateChannelRequest {
  deviceId: number;
  channelId: number;
  channelName: string;
  auditUserId: number;
}

// Obtener canales de una unidad con nombres personalizados
export const getUnitVideoChannels = async (unitId: number): Promise<UnitVideoChannel[]> => {
  try {
    console.log('🌐 API: Fetching video channels for unitId:', unitId);

    const httpWebtrack = new HttpWebtrack();
    configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);

    httpWebtrack.setConfigMessage({
      object: 'video.videoChannels',
      action: 'Get',
      genderType: 'PluralMale'
    });

    // Asegurar que la URL use 'api' en minúsculas para que coincida con el controlador .NET
    const baseUrl = apiConstants.API_URL.replace('/Api/', '/api/');
    const fullUrl = `${baseUrl}/iothub/units/video-channels`;
    console.log('🔗 API: Full URL:', fullUrl);

    const response = (await httpWebtrack.post(fullUrl, { unitId })) as any;
    console.log('📡 API: Raw response:', response);

    // CORRECCIÓN: Verificar 'success' con s minúscula y 'data' en lugar de 'Success' y 'Data'
    if (response?.success) {
      console.log('✅ API: Success response, data:', response.data);
      return response.data || [];
    }

    console.log('⚠️ API: Response not successful:', response);
    return [];
  } catch (error) {
    console.error('❌ API: Error fetching unit video channels:', error);
    return [];
  }
};

// Actualizar nombre de canal
export const updateChannelName = async (
  unitId: number,
  channelId: number,
  request: UpdateChannelNameRequest
): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    console.log(
      '🔄 API: Updating channel name - unitId:',
      unitId,
      'channelId:',
      channelId,
      'request:',
      request
    );

    const httpWebtrack = new HttpWebtrack();
    configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);

    httpWebtrack.setConfigMessage({
      object: 'video.videoChannels',
      action: 'Edit',
      genderType: 'SingularMale'
    });

    // Asegurar que la URL use 'api' en minúsculas para que coincida con el controlador .NET
    const baseUrl = apiConstants.API_URL.replace('/Api/', '/api/');
    const fullUrl = `${baseUrl}/iothub/units/${unitId}/video-channels/${channelId}/name`;
    console.log('🔗 API: Update URL:', fullUrl);

    const response = (await httpWebtrack.post(fullUrl, request)) as any;
    console.log('� API: Update response:', response);

    // CORRECCIÓN: Usar minúsculas para 'success', 'data', 'message'
    const result = {
      success: response?.success || false,
      data: response?.data,
      message: response?.message
    };

    console.log('📝 API: Final update result:', result);
    return result;
  } catch (error) {
    console.error('❌ API: Error updating channel name:', error);
    return {
      success: false,
      message: 'Error al actualizar el nombre del canal'
    };
  }
};

// Crear registro de canal
export const createChannelRecord = async (
  unitId: number,
  request: CreateChannelRequest
): Promise<boolean> => {
  try {
    const httpWebtrack = new HttpWebtrack();
    configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);

    httpWebtrack.setConfigMessage({
      object: 'video.videoChannels',
      action: 'Create',
      genderType: 'SingularMale'
    });

    // Asegurar que la URL use 'api' en minúsculas para que coincida con el controlador .NET
    const baseUrl = apiConstants.API_URL.replace('/Api/', '/api/');
    const response = (await httpWebtrack.post(
      `${baseUrl}/iothub/units/${unitId}/video-channels`,
      request
    )) as any;

    return response?.success || false;
  } catch (error) {
    console.error('Error creating channel record:', error);
    return false;
  }
};
